"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9729],{

/***/ 9729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ForgotSection": function() { return /* binding */ ForgotSection; },
/* harmony export */   "LeftPanel": function() { return /* binding */ LeftPanel; },
/* harmony export */   "PasswordCheckPopup": function() { return /* binding */ PasswordCheckPopup; },
/* harmony export */   "QuizSection": function() { return /* binding */ QuizSection; },
/* harmony export */   "SignInSection": function() { return /* binding */ SignInSection; },
/* harmony export */   "SignUpSection": function() { return /* binding */ SignUpSection; },
/* harmony export */   "SuccessSection": function() { return /* binding */ SuccessSection; },
/* harmony export */   "UsernameSection": function() { return /* binding */ UsernameSection; },
/* harmony export */   "VerifySection": function() { return /* binding */ VerifySection; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Login; },
/* harmony export */   "handleStopScroll": function() { return /* binding */ handleStopScroll; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1455);
/* harmony import */ var _comps_border_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3607);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5896);
/* harmony import */ var _comps_dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3153);
/* harmony import */ var _comps_header_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1817);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9612);
/* harmony import */ var _comps_input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5792);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9034);
/* harmony import */ var _comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9460);
/* harmony import */ var _comps_toggle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7092);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1816);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4371);
/* harmony import */ var _utils_validators__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(9480);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(6010);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3977);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4367);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8767);
/* harmony import */ var statics_offering_prices_json__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8753);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(7632);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(1604);
/* harmony import */ var _comps__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(8014);




































var plans = _comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .pricesSchema.parse */ .R3.parse(statics_offering_prices_json__WEBPACK_IMPORTED_MODULE_21__);
var __N_SSP = true;
function Login(props) {
    var redirect_url = props.redirect_url, type = props.type, expired = props.expired;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(type), page = ref[0], setPage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(""), newPassword = ref2[0], setNewPassword = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(null), quiz = ref3[0], setQuiz = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(false), requested = ref4[0], setRequested = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(type === "signup" ? "txt_signup_title" : "txt_login_title"), metaTitle = ref5[0], setMetaTitle = ref5[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var ref6 = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(), userInfo = ref6.userInfo, setUserInfo = ref6.setUserInfo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_18__.useRouter)();
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    (0,react__WEBPACK_IMPORTED_MODULE_19__.useEffect)(function() {
        var handleRedirectResult = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
                var auth, result, newUserInfo, quizParams, quiz, url, hashEmail, hashedEmail, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setRequested(true);
                            auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_16__/* .getAuth */ .v0)();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                9,
                                ,
                                10
                            ]);
                            return [
                                4,
                                (0,firebase_auth__WEBPACK_IMPORTED_MODULE_16__/* .getRedirectResult */ .cx)(auth)
                            ];
                        case 2:
                            result = _state.sent();
                            if (!result) return [
                                3,
                                8
                            ];
                            return [
                                4,
                                (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .logInWithUserCredential */ .zn)(result)
                            ];
                        case 3:
                            newUserInfo = _state.sent();
                            setUserInfo(newUserInfo);
                            if (!newUserInfo.details.promptOnboarding) return [
                                3,
                                4
                            ];
                            setPage("username");
                            return [
                                2
                            ];
                        case 4:
                            quizParams = {
                                uid: newUserInfo.userId
                            };
                            return [
                                4,
                                axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/quiz", quizParams).then(function(res) {
                                    return res.data;
                                })
                            ];
                        case 5:
                            quiz = _state.sent();
                            if (quiz) {
                                setQuiz(quiz);
                                setPage("quiz");
                                return [
                                    2
                                ];
                            }
                            _state.label = 6;
                        case 6:
                            url = "/";
                            if (typeof redirect_url === "string") {
                                url = redirect_url;
                            }
                            hashEmail = function(email) {
                                if (!email) return null;
                                return crypto__WEBPACK_IMPORTED_MODULE_14___default().createHash("sha256").update(email).digest("hex");
                            };
                            if (type === "signup") {
                                hashedEmail = hashEmail(result.user.email);
                                logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_did_sign_up", {
                                    from: url,
                                    email: hashedEmail
                                });
                            } else if (type === "signin") {
                                logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_did_sign_in", {
                                    from: url
                                });
                            }
                            return [
                                4,
                                router.push(url)
                            ];
                        case 7:
                            _state.sent();
                            setEmail("");
                            _state.label = 8;
                        case 8:
                            setRequested(false);
                            return [
                                3,
                                10
                            ];
                        case 9:
                            error = _state.sent();
                            console.error("Error handling redirect result", error);
                            setRequested(false);
                            return [
                                3,
                                10
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleRedirectResult() {
                return _ref.apply(this, arguments);
            };
        }();
        if (router.isReady) {
            handleRedirectResult();
        }
    }, [
        logAdjust,
        redirect_url,
        router,
        setUserInfo,
        type,
        userInfo, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps__WEBPACK_IMPORTED_MODULE_22__/* .Meta */ .h_, {
                title: t(metaTitle),
                description: t("txt_login_description")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex min-h-[100svh] w-screen flex-row overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftPanel, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative z-[2] flex min-h-[100svh] w-full flex-col items-center justify-start gap-1 overflow-hidden bg-color-surface-cell tablet:justify-between desktop:h-auto desktop:min-h-screen desktop:w-[50%] desktop:overflow-visible",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden h-4 w-full tablet:block"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative flex w-full flex-1 items-center justify-start tablet:justify-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignInSection, {
                                        page: page,
                                        email: email,
                                        setEmail: setEmail,
                                        setPage: setPage,
                                        redirectUrl: redirect_url,
                                        setQuiz: setQuiz,
                                        setMetaTitle: setMetaTitle,
                                        requested: requested,
                                        setRequested: setRequested
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignUpSection, {
                                        page: page,
                                        email: email,
                                        setEmail: setEmail,
                                        setPage: setPage,
                                        redirectUrl: redirect_url,
                                        newPassword: newPassword,
                                        setNewPassword: setNewPassword,
                                        setQuiz: setQuiz,
                                        setMetaTitle: setMetaTitle,
                                        requested: requested,
                                        setRequested: setRequested
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VerifySection, {
                                        page: page,
                                        email: email,
                                        setEmail: setEmail,
                                        setPage: setPage,
                                        redirectUrl: redirect_url,
                                        newPassword: newPassword,
                                        setNewPassword: setNewPassword,
                                        setQuiz: setQuiz,
                                        setMetaTitle: setMetaTitle,
                                        requested: requested,
                                        setRequested: setRequested
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UsernameSection, {
                                        page: page,
                                        email: email,
                                        setEmail: setEmail,
                                        setPage: setPage,
                                        redirectUrl: redirect_url,
                                        newPassword: newPassword,
                                        setNewPassword: setNewPassword,
                                        setQuiz: setQuiz,
                                        setMetaTitle: setMetaTitle,
                                        requested: requested,
                                        setRequested: setRequested
                                    }),
                                    quiz && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuizSection, {
                                        page: page,
                                        quiz: quiz,
                                        setPage: setPage,
                                        requested: requested,
                                        setRequested: setRequested
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlanSection, {
                                        setPage: setPage,
                                        page: page,
                                        redirectUrl: redirect_url,
                                        setMetaTitle: setMetaTitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ForgotSection, {
                                        page: page,
                                        email: email,
                                        setEmail: setEmail,
                                        setPage: setPage,
                                        redirectUrl: redirect_url,
                                        expired: expired,
                                        setQuiz: setQuiz,
                                        setMetaTitle: setMetaTitle,
                                        requested: requested,
                                        setRequested: setRequested
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SuccessSection, {
                                        page: page
                                    })
                                ]
                            }),
                            (page === "signin" || page === "signup") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "hidden tablet:block",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-4 w-full"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("hidden max-w-full self-center pb-7 text-center text-[15px] transition-opacity tablet:block"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t("txt_by_signing_up_you_accept")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/privacy-policy",
                                                className: "mx-1 text-[#007BFF]",
                                                children: t("txt_terms_of_use")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t("lbl_and")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/privacy-policy",
                                                className: "mx-1 text-[#007BFF]",
                                                children: t("txt_privacy_policy")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function LeftPanel() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative z-[1] hidden min-h-screen desktop:block desktop:w-[50%]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pointer-events-none absolute left-0 top-0 h-full w-full select-none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/login/background.webp"),
                    alt: "background image",
                    className: "h-full w-full object-cover"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative flex h-full w-full flex-col items-center justify-between pb-[58px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-[59px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/login/logo.webp"),
                                alt: "logo",
                                className: "h-[71px] w-[171px]"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/login/accounts.webp"),
                        alt: "accounts",
                        className: "pointer-events-none h-[150px] w-[299px] select-none object-cover"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "pointer-events-none w-[458px] select-none text-center text-[40px] font-800 text-blue-800 dark:text-blue-200",
                        children: t("txt_video_creation_platform")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/login/icons.webp"),
                        alt: "accounts",
                        className: "pointer-events-none w-full select-none object-cover"
                    })
                ]
            })
        ]
    });
}
var sectionOrder = {
    plan: 0,
    quiz: 1,
    username: 2,
    verify: 3,
    signup: 4,
    signin: 5,
    forgot: 6,
    success: 7
};
function handleStopScroll(event) {
    event.stopPropagation();
    event.preventDefault();
}
var facebookLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M23.667 12.0669C23.667 5.95335 18.7436 1 12.667 1C6.59038 1 1.66699 5.95335 1.66699 12.0669C1.66699 17.6004 5.65893 22.1968 10.9372 23V15.2799H8.1428V12.0669H10.9372V9.6572C10.9372 6.89047 12.5783 5.3286 15.0622 5.3286C16.3041 5.3286 17.546 5.55172 17.546 5.55172V8.27383H16.171C14.796 8.27383 14.3525 9.1217 14.3525 10.0142V12.0669H17.413L16.9251 15.2799H14.3525V23C19.6307 22.1968 23.667 17.6004 23.667 12.0669Z",
        fill: "var(--facebook-color)"
    })
});
var googleLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.85707 11.9992C5.85707 11.2977 5.97351 10.6251 6.18158 9.99433L2.54164 7.21484C1.83222 8.65513 1.43262 10.2782 1.43262 11.9992C1.43262 13.719 1.83188 15.3408 2.54012 16.7803L6.17804 13.9954C5.97199 13.3675 5.85707 12.6974 5.85707 11.9992Z",
            fill: "#FBBC05"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.2483 5.61743C13.7723 5.61743 15.1488 6.15743 16.2303 7.04101L19.3765 3.89922C17.4593 2.23011 15.0013 1.19922 12.2483 1.19922C7.97422 1.19922 4.30087 3.64339 2.54199 7.21482L6.18176 9.9943C7.02045 7.44854 9.41113 5.61743 12.2483 5.61743Z",
            fill: "#EA4335"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.2483 18.3808C9.4113 18.3808 7.02062 16.5497 6.18193 14.0039L2.54199 16.7829C4.30087 20.3548 7.97422 22.799 12.2483 22.799C14.8862 22.799 17.4048 21.8623 19.295 20.1073L15.84 17.4363C14.8651 18.0504 13.6375 18.3808 12.2483 18.3808Z",
            fill: "#34A853"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.5717 11.9987C22.5717 11.3605 22.4733 10.6732 22.3258 10.0352H12.248V14.2078H18.049C17.7589 15.6306 16.9695 16.7242 15.8397 17.436L19.2947 20.107C21.2802 18.2643 22.5717 15.519 22.5717 11.9987Z",
            fill: "#4285F4"
        })
    ]
});
var appleLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.6661 12.13C18.6368 9.23826 21.0626 7.85131 21.171 7.78124C19.8077 5.81983 17.6838 5.5507 16.9279 5.52008C15.1218 5.33957 13.402 6.5669 12.4857 6.5669C11.5714 6.5669 10.1557 5.54652 8.65806 5.57251C6.68786 5.60128 4.87187 6.70008 3.858 8.43551C1.81189 11.9282 3.33457 17.1043 5.32834 19.939C6.30306 21.3246 7.46547 22.8837 8.99051 22.8266C10.4604 22.7695 11.0149 21.8911 12.7918 21.8911C14.5686 21.8911 15.0676 22.8266 16.6223 22.7974C18.203 22.7691 19.2051 21.3854 20.1718 19.9942C21.2908 18.3845 21.7515 16.8259 21.7789 16.747C21.7444 16.7312 18.6977 15.5828 18.6661 12.13Z",
            fill: "var(--apple-color)"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.7447 3.64487C16.5534 2.67878 17.1014 1.33638 16.9524 0C15.7853 0.0464019 14.3725 0.763312 13.5345 1.72847C12.7838 2.58505 12.1273 3.9488 12.3032 5.26105C13.6052 5.36035 14.9331 4.6091 15.7447 3.64487Z",
            fill: "var(--apple-color)"
        })
    ]
});
var authProviders = [
    {
        name: "Google",
        icon: googleLogo,
        provider: function() {
            var provider = new firebase_auth__WEBPACK_IMPORTED_MODULE_16__/* .GoogleAuthProvider */ .hJ();
            provider.addScope("email");
            return provider;
        }
    },
    {
        name: "Apple",
        icon: appleLogo,
        provider: function() {
            var provider = new firebase_auth__WEBPACK_IMPORTED_MODULE_16__/* .OAuthProvider */ .O4("apple.com");
            provider.addScope("email");
            return provider;
        }
    },
    {
        name: "Facebook",
        icon: facebookLogo,
        provider: function() {
            var provider = new firebase_auth__WEBPACK_IMPORTED_MODULE_16__/* .FacebookAuthProvider */ ._O();
            provider.addScope("email");
            return provider;
        }
    }, 
];
function SuccessSection(param) {
    var page = param.page;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-185px)]", "h-full w-full tablet:w-[375px]", "flex items-center justify-center", "transition-all duration-500", page === "success" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.success ? "translate-y-24" : "-translate-y-24", 
        ]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col items-center gap-3 text-[14px] font-500",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/success-check.svg"),
                    className: "aspect-square w-[60px]",
                    alt: "success check"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-4 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("txt_please_check_email")
                    })
                })
            ]
        })
    });
}
function ForgotSection(props) {
    var page = props.page, email = props.email, setEmail = props.setEmail, setPage = props.setPage, expired = props.expired, requested = props.requested, setRequested = props.setRequested;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var emailValidator = (0,_comps_input__WEBPACK_IMPORTED_MODULE_7__/* .useValidator */ .ny)(email, [
        _utils_validators__WEBPACK_IMPORTED_MODULE_28__/* .notEmpty */ .Dw,
        _utils_validators__WEBPACK_IMPORTED_MODULE_28__/* .isEmail */ .Jh, 
    ]);
    var notCurrent = page !== "forgot";
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    var sendPasswordResetEmail = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .useAuthUpdater */ .Sf)().sendPasswordResetEmail;
    function handleReset(event) {
        return _handleReset.apply(this, arguments);
    }
    function _handleReset() {
        _handleReset = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(event) {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setRequested(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            sendPasswordResetEmail(email)
                        ];
                    case 2:
                        _state.sent();
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("w_dp_send_password_reset_link");
                        setPage("success");
                        setEmail("");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(error, firebase_app__WEBPACK_IMPORTED_MODULE_15__/* .FirebaseError */ .ZR)) {
                            switch(error.code){
                                case "auth/user-not-found":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_user_not_found")
                                    }));
                                    break;
                                default:
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_unexpected_error")
                                    }));
                            }
                        } else {
                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                children: t("txt_unexpected_error")
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setRequested(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleReset.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-185px)]", "h-full w-full tablet:w-[375px]", "flex items-center justify-center", "transition-all duration-500", page === "forgot" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.forgot ? "translate-y-24" : "-translate-y-24", 
        ]),
        onSubmit: handleReset,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full flex-col items-stretch gap-3 px-4 tablet:relative tablet:w-[375px] tablet:px-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mb-4 text-center text-[20px] font-700 text-blue-800",
                    children: t("txt_forgot_password")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute left-2 top-2 tablet:left-0 tablet:top-0", "bg-blue-200 hover:bg-blue-100", "transition-colors duration-200", "h-8 w-8 rounded-full px-3"),
                    onClick: function() {
                        return setPage("signin");
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "6",
                        height: "12",
                        viewBox: "0 0 6 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M5.12969 10.2594L0.871094 6.00078L5.12969 1.74219",
                            stroke: "var(--color-blue-900)",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col items-stretch",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                        name: "email",
                        type: "email",
                        placeholder: t("lbl_email"),
                        className: "!bg-color-background",
                        value: email,
                        disabled: requested || notCurrent,
                        onChange: function onChange(event) {
                            setEmail(event.currentTarget.value);
                        },
                        onBlur: emailValidator.validate
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    type: "submit",
                    className: "mt-4 w-full",
                    text: "common:txt_send_password_reset",
                    loading: requested,
                    disabled: requested || notCurrent,
                    primary: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-[13px] font-400", expired ? "text-color-error" : "text-blue-700"),
                            children: expired ? t("txt_link_expired") : t("txt_we_will_email")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "block h-8 w-full truncate text-center",
                            children: email
                        })
                    ]
                })
            ]
        })
    });
}
function getErrorName(error) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(error, firebase_app__WEBPACK_IMPORTED_MODULE_15__/* .FirebaseError */ .ZR)) {
        switch(error.code){
            case "auth/wrong-password":
                return "txt_wrong_password";
            case "auth/user-not-found":
                return "txt_user_not_found";
            case "auth/too-many-requests":
                return "txt_too_many_requests";
        }
    }
    return "txt_unknown_error";
}
function SignInSection(props) {
    var page = props.page, email = props.email, setEmail = props.setEmail, setPage = props.setPage, redirectUrl = props.redirectUrl, setQuiz = props.setQuiz, setMetaTitle = props.setMetaTitle, requested = props.requested, setRequested = props.setRequested;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_18__.useRouter)();
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var emailValidator = (0,_comps_input__WEBPACK_IMPORTED_MODULE_7__/* .useValidator */ .ny)(email, [
        _utils_validators__WEBPACK_IMPORTED_MODULE_28__/* .notEmpty */ .Dw,
        _utils_validators__WEBPACK_IMPORTED_MODULE_28__/* .isEmail */ .Jh, 
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(""), password = ref[0], setPassword = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(true), passwordHidden = ref1[0], setPasswordHidden = ref1[1];
    var notCurrent = page !== "signin";
    var ref2 = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .useAuthUpdater */ .Sf)(), signInWithEmailAndPassword = ref2.logInWithEmailAndPassword;
    function handleSignIn(event) {
        return _handleSignIn.apply(this, arguments);
    }
    function _handleSignIn() {
        _handleSignIn = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(event) {
            var userInfo, quizParams, quiz, url, error, errorText;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (email.trim().length === 0 || password.trim().length === 0) return [
                            2
                        ];
                        setRequested(true);
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_sign_in", {
                            from: typeof redirectUrl === "string" ? redirectUrl : "home",
                            type: "email"
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            signInWithEmailAndPassword(email, password)
                        ];
                    case 2:
                        userInfo = _state.sent();
                        if (!userInfo.details.promptOnboarding) return [
                            3,
                            3
                        ];
                        setPage("username");
                        setRequested(false);
                        return [
                            2
                        ];
                    case 3:
                        quizParams = {
                            uid: userInfo.userId
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/quiz", quizParams).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 4:
                        quiz = _state.sent();
                        if (quiz) {
                            setQuiz(quiz);
                            setPage("quiz");
                            setRequested(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 5;
                    case 5:
                        url = "/";
                        if (typeof redirectUrl === "string") {
                            url = redirectUrl;
                        }
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_did_sign_in", {
                            from: url
                        });
                        return [
                            4,
                            router.push(url)
                        ];
                    case 6:
                        _state.sent();
                        setEmail("");
                        setPassword("");
                        setPasswordHidden(true);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.error(error);
                        errorText = getErrorName(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t(errorText)
                        }));
                        return [
                            3,
                            8
                        ];
                    case 8:
                        setRequested(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSignIn.apply(this, arguments);
    }
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    var logInWithProvider = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .useAuthUpdater */ .Sf)().logInWithProvider;
    function handleProviderSignIn(provider, name) {
        return _handleProviderSignIn.apply(this, arguments);
    }
    function _handleProviderSignIn() {
        _handleProviderSignIn = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(provider, name) {
            var errorText;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                setRequested(true);
                logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_sign_in", {
                    from: typeof redirectUrl === "string" ? redirectUrl : "home",
                    type: name
                });
                try {
                    logInWithProvider(provider);
                // await logInWithProvider(provider)
                // if (userInfo.details.promptOnboarding) {
                // 	setPage("username")
                // 	setRequested(false)
                // 	return
                // } else {
                // 	const quizParams = {
                // 		uid: userInfo.userId,
                // 	}
                // 	const quiz = await axios
                // 		.post<Quiz | null>("/api/quiz", quizParams)
                // 		.then((res) => res.data)
                // 	if (quiz) {
                // 		setQuiz(quiz)
                // 		setPage("quiz")
                // 		setRequested(false)
                // 		return
                // 	}
                // }
                // let url = "/"
                // if (typeof redirectUrl === "string") {
                // 	url = redirectUrl
                // }
                // logAdjust?.logEventWithPayload("w_did_sign_in", {
                // 	from: url,
                // })
                // await router.push(url)
                // setEmail("")
                // setPassword("")
                // setPasswordHidden(true)
                } catch (error) {
                    console.error(error);
                    errorText = getErrorName(error);
                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                        children: t(errorText)
                    }));
                }
                setRequested(false);
                return [
                    2
                ];
            });
        });
        return _handleProviderSignIn.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-185px)]", "h-full w-full tablet:w-[375px]", "flex justify-center tablet:items-center tablet:pt-0", "pb-[60px] transition-all duration-500 tablet:pb-0", page === "signin" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.signin ? "translate-y-24" : "-translate-y-24", 
        ]),
        onSubmit: handleSignIn,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "no-scrollbar flex w-full flex-col items-stretch gap-3 overflow-auto px-4 pt-8 tablet:w-[375px] tablet:px-0 tablet:pt-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex w-full items-center justify-center desktop:hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header_icon__WEBPACK_IMPORTED_MODULE_5__/* .Logo */ .TR, {
                        showOnMobile: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mb-4 text-center text-[20px] font-700 text-blue-800",
                    children: t("txt_sign_in_zoomerang")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-[148px] shrink-0 flex-col gap-2 [--apple-color:#121212] [--facebook-color:#345287] dark:[--apple-color:#ffffff] dark:[--facebook-color:#ffffff] tablet:h-[166px]",
                    children: authProviders.map(function(authProvider, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            type: "button",
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative h-[44px] w-full shrink-0 gap-3 rounded-lg font-500 tablet:h-[50px]", "bg-blue-100 hover:bg-blue-200 disabled:hover:bg-blue-100", "transition-colors duration-300 ease-in-out", "flex flex-1 items-center justify-center"),
                            onClick: function() {
                                return handleProviderSignIn(authProvider.provider(), authProvider.name);
                            },
                            disabled: notCurrent || requested,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute left-3 top-[9px] tablet:left-[15px] tablet:top-[12px]",
                                    children: authProvider.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: " text-[15px] font-500 text-blue-700",
                                    children: t("fs_continue_with", {
                                        provider: authProvider.name
                                    })
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[1px] flex-1 bg-color-separator"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "select-none text-[13px] font-400 text-blue-700",
                            children: t("lbl_or")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[1px] flex-1 bg-color-separator"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col items-stretch",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                        name: "email",
                        type: "email",
                        value: email,
                        placeholder: t("lbl_email"),
                        disabled: requested || notCurrent,
                        className: " !h-11 !bg-color-background tablet:!h-[50px]",
                        onChange: function onChange(event) {
                            setEmail(event.currentTarget.value);
                        },
                        onBlur: emailValidator.validate
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative flex flex-col items-stretch overflow-visible",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                                name: "password",
                                placeholder: t("lbl_password"),
                                type: passwordHidden ? "password" : "text",
                                disabled: requested || notCurrent,
                                className: "peer !h-11 w-full !bg-color-background pr-12 tablet:!h-[50px]",
                                onChange: function(event) {
                                    return setPassword(event.currentTarget.value);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                disabled: passwordHidden || notCurrent || password.length === 0,
                                onClick: function() {
                                    return setPasswordHidden(true);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-2 top-1/2 -translate-y-1/2 p-2", "transition-opacity duration-150", passwordHidden && "pointer-events-none opacity-0", password.length === 0 && "pointer-events-none opacity-0"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/eye-icon-closed.svg"),
                                    alt: "show password"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                disabled: !passwordHidden || notCurrent || password.length === 0,
                                onClick: function() {
                                    return setPasswordHidden(false);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-2 top-1/2 -translate-y-1/2 p-2", "transition-opacity duration-150", !passwordHidden && "pointer-events-none opacity-0", password.length === 0 && "pointer-events-none opacity-0"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/eye-icon.svg"),
                                    alt: "hide password"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("self-end text-[14px] font-400 text-blue-500 tablet:self-center", "underline decoration-blue-500 hover:!decoration-blue-500 tablet:decoration-[transparent]", "transition-colors duration-200 ease-in-out", "cursor-pointer"),
                    onClick: function() {
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("w_dp_forgot_password");
                        setPage("forgot");
                    },
                    children: t("txt_dont_remember_password")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    type: "submit",
                    className: "w-full tablet:mt-2",
                    text: "lbl_signin",
                    loading: requested,
                    disabled: requested || notCurrent,
                    primary: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "max-w-full self-center pb-4 text-center text-[12px] tablet:hidden tablet:pb-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("txt_by_signing_up_you_accept")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/privacy-policy",
                            className: "mx-1 text-[#007BFF]",
                            children: t("txt_terms_of_use")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("lbl_and")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/privacy-policy",
                            className: "mx-1 text-[#007BFF]",
                            children: t("txt_privacy_policy")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("fixed bottom-0 left-0 z-[7] w-full bg-color-cell tablet:relative tablet:bg-[transparent]", "border-t border-color-separator tablet:border-[transparent]", "flex justify-center"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        type: "button",
                        className: "h-[60px] text-[15px] tablet:h-auto",
                        onClick: function() {
                            setPage("signup");
                            setMetaTitle("txt_signup_title");
                        },
                        children: [
                            t("txt_dont_have_account"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                className: "ml-1 font-700 text-primary-500",
                                children: t("lbl_signup")
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function SignUpSection(props) {
    var page = props.page, email = props.email, setEmail = props.setEmail, setPage = props.setPage, password = props.newPassword, setPassword = props.setNewPassword, redirectUrl = props.redirectUrl, setMetaTitle = props.setMetaTitle, requested = props.requested, setRequested = props.setRequested;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var notCurrent = page !== "signup";
    var emailValidator = (0,_comps_input__WEBPACK_IMPORTED_MODULE_7__/* .useValidator */ .ny)(email, [
        _utils_validators__WEBPACK_IMPORTED_MODULE_28__/* .notEmpty */ .Dw,
        _utils_validators__WEBPACK_IMPORTED_MODULE_28__/* .isEmail */ .Jh, 
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(""), confirm = ref[0], setConfirm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(true), passwordHidden = ref1[0], setPasswordHidden = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(true), confirmHidden = ref2[0], setConfirmHidden = ref2[1];
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    var ref3 = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .useAuthUpdater */ .Sf)(), signInWithPopup = ref3.logInWithProvider;
    function checkEmail(event) {
        return _checkEmail.apply(this, arguments);
    }
    function _checkEmail() {
        _checkEmail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(event) {
            var canContinue, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (email.trim().length === 0 || password.trim().length === 0) return [
                            2
                        ];
                        setRequested(true);
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_sign_up", {
                            from: typeof redirectUrl === "string" ? redirectUrl : "home",
                            type: "email"
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/verify-email", {
                                email: email
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        canContinue = _state.sent();
                        if (canContinue.status === true) {
                            setPage("verify");
                            setPasswordHidden(true);
                            setConfirm("");
                            setConfirmHidden(true);
                            setRequested(false);
                            return [
                                2
                            ];
                        } else {
                            switch(canContinue.code){
                                case "already_linked":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_email_already_in_use")
                                    }));
                                    break;
                                case "invalid_email":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_email_not_valid")
                                    }));
                                    break;
                                default:
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_email_already_in_use")
                                    }));
                                    break;
                            }
                            setRequested(false);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("txt_couldnt_create_account")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setRequested(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _checkEmail.apply(this, arguments);
    }
    function handleProviderSignIn(provider, name) {
        return _handleProviderSignIn.apply(this, arguments);
    }
    function _handleProviderSignIn() {
        _handleProviderSignIn = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(provider, name) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                setRequested(true);
                logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_sign_up", {
                    from: typeof redirectUrl === "string" ? redirectUrl : "home",
                    type: name
                });
                try {
                    signInWithPopup(provider);
                // if (userInfo.details.promptOnboarding) {
                // 	setPage("username")
                // 	setRequested(false)
                // 	return
                // } else {
                // 	const quizParams = {
                // 		uid: userInfo.userId,
                // 	}
                // 	const quiz = await axios
                // 		.post<Quiz | null>("/api/quiz", quizParams)
                // 		.then((res) => res.data)
                // 	if (quiz) {
                // 		setQuiz(quiz)
                // 		setPage("quiz")
                // 		setRequested(false)
                // 		return
                // 	}
                // }
                // let url = "/"
                // if (typeof redirectUrl === "string") {
                // 	url = redirectUrl
                // }
                // const hashEmail = (email: string | null) => {
                // 	if (!email) return null
                // 	return crypto
                // 		.createHash("sha256")
                // 		.update(email)
                // 		.digest("hex")
                // }
                // const hashedEmail = hashEmail(email)
                // logAdjust?.logEventWithPayload("w_did_sign_up", {
                // 	from: url,
                // 	email: hashedEmail,
                // })
                // await router.push(url)
                // setEmail("")
                // setPassword("")
                } catch (error) {
                    console.error(error);
                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                        children: t("txt_couldnt_create_account")
                    }));
                }
                setRequested(false);
                return [
                    2
                ];
            });
        });
        return _handleProviderSignIn.apply(this, arguments);
    }
    var notSamePassword = password !== confirm;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-185px)]", "h-full w-full tablet:w-[375px]", "flex flex-col justify-start tablet:items-center tablet:justify-center tablet:pt-0", "pb-[60px] transition-all duration-500 tablet:pb-0", page === "signup" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.signup ? "translate-y-24" : "-translate-y-24", 
        ]),
        onSubmit: checkEmail,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "no-scrollbar flex h-full w-full flex-col items-stretch gap-3 overflow-auto px-4 pt-8 tablet:h-auto tablet:w-[375px] tablet:overflow-visible tablet:px-0 tablet:pt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full items-center justify-center desktop:hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header_icon__WEBPACK_IMPORTED_MODULE_5__/* .Logo */ .TR, {
                            showOnMobile: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "mb-4 w-[280px] text-center text-[20px] font-700 text-blue-800",
                            id: "signup-title",
                            children: t("txt_you_need_account")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex h-[148px] shrink-0 flex-col gap-2 [--apple-color:#121212] [--facebook-color:#345287] dark:[--apple-color:#ffffff] dark:[--facebook-color:#ffffff] tablet:h-[166px]",
                        children: authProviders.map(function(authProvider, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                type: "button",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative h-[44px] w-full shrink-0 gap-3 rounded-lg font-500 tablet:h-[50px]", "bg-blue-100 hover:bg-blue-200 disabled:hover:bg-blue-100", "transition-colors duration-300 ease-in-out", "flex flex-1 items-center justify-center"),
                                onClick: function() {
                                    return handleProviderSignIn(authProvider.provider(), authProvider.name);
                                },
                                disabled: notCurrent || requested,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute left-3 top-[9px] tablet:left-[15px] tablet:top-[12px]",
                                        children: authProvider.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: " text-[15px] font-500 text-blue-700",
                                        children: t("fs_continue_with", {
                                            provider: authProvider.name
                                        })
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[1px] flex-1 bg-color-separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "select-none text-[13px] font-400 text-blue-700",
                                children: t("lbl_or")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[1px] flex-1 bg-color-separator"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                        name: "email",
                        className: " !h-11 !bg-color-background tablet:!h-[50px]",
                        placeholder: t("lbl_email"),
                        type: "email",
                        value: email,
                        disabled: requested || notCurrent,
                        onChange: function onChange(event) {
                            setEmail(event.currentTarget.value);
                        },
                        onBlur: emailValidator.validate
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex flex-col items-stretch overflow-visible",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                                    name: "password",
                                    placeholder: t("lbl_password"),
                                    type: passwordHidden ? "password" : "text",
                                    value: password,
                                    disabled: requested || notCurrent,
                                    className: "peer !h-11 w-full !bg-color-background pr-12 tablet:!h-[50px]",
                                    onChange: function(event) {
                                        return setPassword(event.currentTarget.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PasswordCheckPopup, {
                                    password: password
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    disabled: passwordHidden || notCurrent || password.length === 0,
                                    onClick: function() {
                                        return setPasswordHidden(true);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-2 top-1/2 -translate-y-1/2 p-2", "transition-opacity duration-150", passwordHidden && "pointer-events-none opacity-0", password.length === 0 && "pointer-events-none opacity-0"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/eye-icon-closed.svg"),
                                        alt: "show password"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    disabled: !passwordHidden || notCurrent || password.length === 0,
                                    onClick: function() {
                                        return setPasswordHidden(false);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-2 top-1/2 -translate-y-1/2 p-2", "transition-opacity duration-150", !passwordHidden && "pointer-events-none opacity-0", password.length === 0 && "pointer-events-none opacity-0"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/eye-icon.svg"),
                                        alt: "hide password"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex flex-col items-stretch overflow-visible",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                                    name: "password",
                                    placeholder: t("txt_confirm_password"),
                                    type: confirmHidden ? "password" : "text",
                                    className: "peer !h-11 w-full !bg-color-background pr-12 tablet:!h-[50px]",
                                    value: confirm,
                                    disabled: requested || notCurrent,
                                    onChange: function(event) {
                                        return setConfirm(event.currentTarget.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    disabled: confirmHidden || notCurrent,
                                    onClick: function() {
                                        return setConfirmHidden(true);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-2 top-1/2 -translate-y-1/2 p-2", "transition-opacity duration-150", confirmHidden && "pointer-events-none opacity-0", confirm.length === 0 && "pointer-events-none opacity-0"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/eye-icon-closed.svg"),
                                        alt: "hide password"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    disabled: !confirmHidden || notCurrent,
                                    onClick: function() {
                                        return setConfirmHidden(false);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-2 top-1/2 -translate-y-1/2 p-2", "transition-opacity duration-150", !confirmHidden && "pointer-events-none opacity-0", confirm.length === 0 && "pointer-events-none opacity-0"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/eye-icon.svg"),
                                        alt: "show password"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        type: "submit",
                        className: "w-full",
                        text: "lbl_next",
                        loading: requested,
                        disabled: requested || notCurrent || notSamePassword || password.trim().length === 0 || email.trim().length === 0,
                        primary: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "max-w-full self-center pb-4 text-center text-[12px] tablet:hidden tablet:pb-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("txt_by_signing_up_you_accept")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/privacy-policy",
                                className: "mx-1 text-[#007BFF]",
                                children: t("txt_terms_of_use")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("lbl_and")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/privacy-policy",
                                className: "mx-1 text-[#007BFF]",
                                children: t("txt_privacy_policy")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("fixed bottom-0 left-0 z-[41] w-full bg-color-cell tablet:relative tablet:z-[30] tablet:mt-2 tablet:bg-[transparent]", "border-t border-color-separator tablet:mt-[16px] tablet:border-[transparent]", "flex justify-center"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: "h-[60px] text-[15px] tablet:h-auto",
                    onClick: function() {
                        setPage("signin");
                        setMetaTitle("txt_login_title");
                    },
                    children: [
                        t("txt_already_have_account"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            className: "ml-1 font-700 text-primary-500",
                            children: t("lbl_signin")
                        })
                    ]
                })
            })
        ]
    });
}
function VerifySection(props) {
    var page = props.page, email = props.email, setPage = props.setPage, password = props.newPassword, redirectUrl = props.redirectUrl, setQuiz = props.setQuiz, requested = props.requested, setRequested = props.setRequested;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_18__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(""), code = ref[0], setCode = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(false), hasError = ref1[0], setHasError = ref1[1];
    var inputRefs = (0,react__WEBPACK_IMPORTED_MODULE_19__.useRef)(Array(6).fill(null));
    var notCurrent = page !== "verify";
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    var createUserWithEmailAndPassword = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .useAuthUpdater */ .Sf)().createUserWithEmailAndPassword;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(60), timer = ref2[0], setTimer = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_19__.useEffect)(function() {
        if (timer === 0 || notCurrent) return;
        var intervalId = setInterval(function() {
            setTimer(function(prevTimer) {
                return prevTimer - 1;
            });
        }, 1000);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        notCurrent,
        timer
    ]);
    var minutes = Math.floor(timer / 60);
    var seconds = timer % 60;
    var timerDisplay = "".concat(minutes.toString().padStart(2, "0"), ":").concat(seconds.toString().padStart(2, "0"));
    function handleResend() {
        return _handleResend.apply(this, arguments);
    }
    function _handleResend() {
        _handleResend = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setTimer(60);
                        if (email.trim().length === 0) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/verify-email", {
                                email: email
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("txt_something_wrong")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleResend.apply(this, arguments);
    }
    var errorSchema = zod__WEBPACK_IMPORTED_MODULE_30__.z.object({
        code: zod__WEBPACK_IMPORTED_MODULE_30__.z.string()
    });
    function handleSignUp(submitCode) {
        return _handleSignUp.apply(this, arguments);
    }
    function _handleSignUp() {
        _handleSignUp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(submitCode) {
            var canContinue, userInfo, hashEmail, hashedEmail, quizParams, quiz, url, error, parsedError;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (email.trim().length === 0 || password.trim().length === 0 || requested) return [
                            2
                        ];
                        setRequested(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/verify-email-code", {
                                email: email,
                                code: submitCode
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        canContinue = _state.sent();
                        if (!canContinue) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            createUserWithEmailAndPassword(email, password)
                        ];
                    case 3:
                        userInfo = _state.sent();
                        hashEmail = function(email) {
                            return crypto__WEBPACK_IMPORTED_MODULE_14___default().createHash("sha256").update(email).digest("hex");
                        };
                        hashedEmail = hashEmail(email);
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_did_sign_up", {
                            from: typeof redirectUrl === "string" ? redirectUrl : "home",
                            email: hashedEmail
                        });
                        if (!userInfo.details.promptOnboarding) return [
                            3,
                            4
                        ];
                        setPage("username");
                        setRequested(false);
                        return [
                            2
                        ];
                    case 4:
                        quizParams = {
                            uid: userInfo.userId
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/quiz", quizParams).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 5:
                        quiz = _state.sent();
                        if (quiz) {
                            setQuiz(quiz);
                            setPage("quiz");
                            setRequested(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 6;
                    case 6:
                        url = "/";
                        if (typeof redirectUrl === "string") {
                            url = redirectUrl;
                        }
                        return [
                            4,
                            router.push(url)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        setHasError(true);
                        setRequested(false);
                        return [
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        console.error(error);
                        try {
                            parsedError = errorSchema.parse(error);
                            switch(parsedError.code){
                                case "auth/email-already-in-use":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_email_already_in_use")
                                    }));
                                    break;
                                case "auth/invalid-email":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_email_not_valid")
                                    }));
                                    break;
                                case "auth/operation-not-allowed":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_operation_not_allowed")
                                    }));
                                    break;
                                case "auth/weak-password":
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_password_too_weak")
                                    }));
                                    break;
                                default:
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_couldnt_create_account")
                                    }));
                                    break;
                            }
                        } catch (validationError) {
                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                children: t("txt_couldnt_create_account")
                            }));
                        }
                        return [
                            3,
                            11
                        ];
                    case 11:
                        setRequested(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSignUp.apply(this, arguments);
    }
    var handleChange = function(index, value) {
        var sanitizedValue = value.replace(/\D/g, "");
        var characters = sanitizedValue.split("");
        characters.forEach(function(character, i) {
            var newIndex = index + i;
            if (newIndex < inputRefs.current.length) {
                setCode(function(prevCode) {
                    var newCode = prevCode.split("");
                    newCode[newIndex] = character;
                    return newCode.join("");
                });
            }
        });
        var lastFilledIndex = index + characters.length - 1;
        if (lastFilledIndex >= inputRefs.current.length) {
            var ref;
            (ref = inputRefs.current[inputRefs.current.length - 1]) === null || ref === void 0 ? void 0 : ref.focus();
        } else {
            var ref1;
            (ref1 = inputRefs.current[lastFilledIndex + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    var handleKeyDown = function(index, e) {
        var ref, ref1;
        if (e.key === "ArrowLeft") {
            e.preventDefault();
            if (index > 0) {
                var ref2;
                (ref2 = inputRefs.current[index - 1]) === null || ref2 === void 0 ? void 0 : ref2.focus();
            }
        } else if (e.key === "ArrowRight") {
            e.preventDefault();
            if (index < inputRefs.current.length - 1) {
                var ref3;
                (ref3 = inputRefs.current[index + 1]) === null || ref3 === void 0 ? void 0 : ref3.focus();
            }
        } else if (e.key === "Backspace" && index >= 0 && ((ref = inputRefs.current[index]) === null || ref === void 0 ? void 0 : ref.selectionStart) === 0) {
            e.preventDefault();
            setCode(function(prevCode) {
                var ref;
                var newCode = prevCode.split("");
                newCode[index - 1] = "";
                var updatedCode = newCode.join("");
                (ref = inputRefs.current[index - 1]) === null || ref === void 0 ? void 0 : ref.focus();
                return updatedCode;
            });
        } else if (e.key === "Backspace" && index >= 0 && ((ref1 = inputRefs.current[index]) === null || ref1 === void 0 ? void 0 : ref1.selectionStart) === 1) {
            e.preventDefault();
            setCode(function(prevCode) {
                var ref;
                var newCode = prevCode.split("");
                newCode[index] = "";
                var updatedCode = newCode.join("");
                (ref = inputRefs.current[index - 1]) === null || ref === void 0 ? void 0 : ref.focus();
                return updatedCode;
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-185px)]", "h-full w-full tablet:w-[375px]", "flex items-center justify-center", "transition-all duration-500", page === "verify" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.verify ? "translate-y-24" : "-translate-y-24", 
        ]),
        onSubmit: function(e) {
            e.preventDefault();
            handleSignUp(code);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full flex-col items-stretch gap-3 px-4 tablet:relative tablet:w-[375px] tablet:px-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-center text-[20px] font-700 text-blue-800",
                    children: t("txt_confirm_your_email")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mb-4 text-center text-[18px] font-500 text-blue-600",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("txt_enter_verification_code")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: email
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute left-2 top-2 tablet:-top-16 tablet:left-0", "bg-blue-200 hover:bg-blue-100", "transition-colors duration-200", "h-8 w-8 rounded-full px-3"),
                    onClick: function() {
                        return setPage("signup");
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "6",
                        height: "12",
                        viewBox: "0 0 6 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M5.12969 10.2594L0.871094 6.00078L5.12969 1.74219",
                            stroke: "var(--color-blue-900)",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-row items-center justify-center gap-[9px]",
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(Array(6)).map(function(_, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    ref: function(ref) {
                                        return inputRefs.current[index] = ref;
                                    },
                                    type: "text",
                                    pattern: "[0-9]*",
                                    value: code[index] || "",
                                    onChange: function(e) {
                                        return handleChange(index, e.target.value);
                                    },
                                    onKeyDown: function(e) {
                                        return handleKeyDown(index, e);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("border-[1.5px]", "bg-color-cell outline-none", "rounded-[8px]", "h-[50px] w-[50px] placeholder-color-placeholder", "no-autofill text-center transition-all duration-200", hasError && code.length === 6 ? "border-color-error" : "border-color-separator focus:border-blue-500")
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(" px-4 text-[14px] font-500 text-color-error transition-opacity", (!hasError || code.length !== 6) && "pointer-events-none select-none opacity-0"),
                            children: t("txt_code_doesnt_exist")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    type: "submit",
                    className: "atablet:mt-[150px] w-full",
                    text: "lbl_next",
                    loading: requested,
                    disabled: requested || notCurrent || code.length !== 6,
                    primary: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-center text-[15px] font-400 text-blue-800",
                    children: t("txt_didnt_receive_email")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-center text-[16px] font-500 text-blue-600",
                            children: timerDisplay
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                handleResend();
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-center text-[16px] font-500", timer === 0 ? "text-primary-500" : "text-primary-500/30 pointer-events-none cursor-not-allowed"),
                            children: t("txt_resend_code")
                        })
                    ]
                })
            ]
        })
    });
}
function UsernameSection(props) {
    var page = props.page, redirectUrl = props.redirectUrl, setPage = props.setPage, setQuiz = props.setQuiz, requested = props.requested, setRequested = props.setRequested;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var ref = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(), userInfo = ref.userInfo, setUserInfo = ref.setUserInfo;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)("@"), username = ref1[0], setUsername = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(""), fullName = ref2[0], setFullName = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(false), usernameError = ref3[0], setUsernameError = ref3[1];
    var months = [
        "txt_january",
        "txt_february",
        "txt_march",
        "txt_april",
        "txt_may",
        "txt_june",
        "txt_july",
        "txt_august",
        "txt_september",
        "txt_october",
        "txt_november",
        "txt_december", 
    ];
    var currentYear = new Date().getFullYear();
    var years = Array.from({
        length: 100
    }, function(_, i) {
        return currentYear - i - 13;
    });
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(null), selectedDay = ref4[0], setSelectedDay = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(null), selectedMonth = ref5[0], setSelectedMonth = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(null), selectedYear = ref6[0], setSelectedYear = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(Array.from({
        length: 31
    }, function(_, i) {
        return i + 1;
    })), days = ref7[0], setDays = ref7[1];
    var isDateNull = selectedMonth === null || selectedYear === null || selectedDay === null;
    var notCurrent = page !== "username";
    var canSubmit = fullName.trim().length !== 0;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_18__.useRouter)();
    var updateDays = (0,react__WEBPACK_IMPORTED_MODULE_19__.useCallback)(function(month, year) {
        if (month === null || year === null) return [];
        var daysInMonth = new Date(year, month, 0).getDate();
        var newDays = Array.from({
            length: daysInMonth
        }, function(_, i) {
            return i + 1;
        });
        if (selectedDay !== null && selectedDay <= daysInMonth) {
            setSelectedDay(selectedDay);
        } else if (selectedDay !== null && selectedDay > daysInMonth) {
            setSelectedDay(daysInMonth);
        }
        setDays(newDays);
        return newDays;
    }, [
        selectedDay
    ]);
    function handleSignUp(e) {
        return _handleSignUp.apply(this, arguments);
    }
    function _handleSignUp() {
        _handleSignUp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(e) {
            var birthdate, currentDate, age, dateNumber, randomString, randomUsername, match, usernameToSend, isAvailable, quizParams, quiz, url, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!canSubmit || isDateNull) {
                            return [
                                2
                            ];
                        }
                        setRequested(true);
                        birthdate = new Date(selectedYear, selectedMonth - 1, selectedDay);
                        currentDate = new Date();
                        age = currentDate.getFullYear() - birthdate.getFullYear();
                        if (currentDate.getMonth() < birthdate.getMonth() || currentDate.getMonth() === birthdate.getMonth() && currentDate.getDate() < birthdate.getDate()) {
                            age--;
                        }
                        if (age < 13) {
                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                children: t("txt_age_under_13")
                            }));
                            setRequested(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        dateNumber = birthdate.getTime();
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/user-birthdate", {
                                birthdate: dateNumber
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/user-fullname", {
                                full_name: fullName
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 3:
                        _state.sent();
                        randomString = Math.random().toString(36).substring(2, 14);
                        randomUsername = "user".concat(randomString);
                        match = username.trim().match(/@(\w+)/);
                        usernameToSend = match ? match[1] : randomUsername;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/user-username", {
                                username: username.trim() !== "@" ? usernameToSend.replace(/ /g, "_") : randomUsername
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 4:
                        isAvailable = _state.sent();
                        if (!isAvailable) {
                            setUsernameError(true);
                            setRequested(false);
                            return [
                                2
                            ];
                        }
                        (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* .forceRefreshToken */ .EF)().then(function(userInfo) {
                            return setUserInfo(userInfo);
                        }).catch(function(error) {
                            return console.error("Could not get new token", error);
                        });
                        quizParams = {
                            uid: userInfo.userId
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/quiz", quizParams).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 5:
                        quiz = _state.sent();
                        if (quiz) {
                            setQuiz(quiz);
                            setPage("quiz");
                            setRequested(false);
                            return [
                                2
                            ];
                        }
                        url = "/";
                        if (typeof redirectUrl === "string") {
                            url = redirectUrl;
                        }
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("w_onboarding_success");
                        return [
                            4,
                            router.push(url)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("txt_something_wrong")
                        }));
                        return [
                            3,
                            8
                        ];
                    case 8:
                        setRequested(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSignUp.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-185px)]", "h-full w-full tablet:w-[375px]", "flex items-center justify-center", "transition-all duration-500", page === "username" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.username ? "translate-y-24" : "-translate-y-24", 
        ]),
        onSubmit: handleSignUp,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full flex-col items-stretch gap-3 px-4 tablet:relative tablet:w-[375px] tablet:px-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-4 flex flex-col gap-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-center text-[24px] font-700 text-blue-800",
                        children: t("txt_account_information")
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                            name: "username",
                            type: "text",
                            placeholder: "@" + t("lbl_username"),
                            className: "!bg-color-background",
                            hasErrors: usernameError,
                            value: username.trim() === "@" ? "" : username,
                            disabled: requested || notCurrent,
                            onChange: function onChange(event) {
                                setUsernameError(false);
                                var newValue = event.currentTarget.value;
                                if (newValue === "") {
                                    setUsername("@");
                                } else if (newValue.startsWith("@") && newValue.length === 1) {
                                    setUsername("@");
                                } else {
                                    setUsername(newValue.startsWith("@") ? newValue : "@".concat(newValue));
                                }
                            }
                        }),
                        usernameError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-[14px] font-500 text-color-error",
                            children: t("txt_username_used")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                    name: "full_name",
                    type: "text",
                    placeholder: t("lbl_full_name"),
                    className: "!bg-color-background",
                    value: fullName,
                    disabled: requested || notCurrent,
                    onChange: function onChange(event) {
                        setFullName(event.currentTarget.value);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full flex-row gap-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("transition-opacity", requested && "pointer-events-none cursor-crosshair opacity-30"),
                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-5", "h-11 w-[100px] rounded-[8px] bg-color-background tablet:h-[50px]", "border-[1.5px] border-color-separator focus:border-blue-500"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-[16px] font-400", selectedYear === null ? "text-color-placeholder" : "text-blue-700"),
                                        children: selectedYear !== null ? selectedYear : t("txt_year")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .ButtonArrowIcon */ .hd, {})
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-10 w-[100px] pt-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "no-scrollbar max-h-[200px] w-full overflow-y-scroll rounded-[10px] bg-color-popup-cell px-[10px] py-[10px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex w-full flex-col gap-1",
                                        children: years.map(function(year) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center justify-center rounded-[8px] py-2 text-center text-[14px] font-500 text-blue-800 transition-all", selectedYear === year ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                                                onClick: function() {
                                                    setSelectedYear(year);
                                                    updateDays(selectedMonth, year);
                                                },
                                                children: year
                                            }, year);
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex-1 transition-opacity", requested && "pointer-events-none cursor-crosshair opacity-30"),
                            triggerClassName: "w-full tablet:w-[157px]",
                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-5", "h-11 w-full rounded-[8px] bg-color-background tablet:h-[50px] tablet:w-[157px]", "border-[1.5px] border-color-separator focus:border-blue-500"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-[16px] font-400", selectedMonth === null ? "text-color-placeholder" : "text-blue-700"),
                                        children: selectedMonth !== null ? t(months[selectedMonth - 1]) : t("txt_month")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .ButtonArrowIcon */ .hd, {})
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-10 w-[130px] pt-2 tablet:w-[157px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "no-scrollbar max-h-[200px] w-full overflow-y-scroll rounded-[10px] bg-color-popup-cell px-[10px] py-[10px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex w-full flex-col gap-1",
                                        children: months.map(function(month, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center rounded-[8px] py-2 pl-4 text-[14px] font-500 text-blue-800 transition-all", selectedMonth === index + 1 ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                                                onClick: function() {
                                                    setSelectedMonth(index + 1);
                                                    updateDays(index + 1, selectedYear);
                                                },
                                                children: t(month)
                                            }, index);
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("transition-opacity", requested && "pointer-events-none cursor-crosshair opacity-30"),
                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-5", "h-11 w-[100px] rounded-[8px] bg-color-background transition-opacity tablet:h-[50px]", "border-[1.5px] border-color-separator focus:border-blue-500"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-[16px] font-400", selectedDay === null ? "text-color-placeholder" : "text-blue-700"),
                                        children: selectedDay !== null ? selectedDay : t("txt_day")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .ButtonArrowIcon */ .hd, {})
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-10 w-[100px] pt-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "no-scrollbar max-h-[200px] w-full overflow-y-scroll rounded-[10px] bg-color-popup-cell px-[10px] py-[10px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex w-full flex-col gap-1",
                                        children: days.map(function(day) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center justify-center rounded-[8px] py-2 text-center text-[14px] font-500 text-blue-800 transition-all", selectedDay === day ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                                                onClick: function() {
                                                    return setSelectedDay(day);
                                                },
                                                children: day
                                            }, day);
                                        })
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    type: "submit",
                    className: "w-full disabled:!bg-blue-200 disabled:!text-blue-400 disabled:hover:!bg-blue-200 tablet:mt-[50px]",
                    text: "lbl_create",
                    loading: requested,
                    disabled: requested || notCurrent || !canSubmit || isDateNull,
                    primary: true
                })
            ]
        })
    });
}
function QuizSection(props) {
    var page = props.page, quiz = props.quiz, setPage = props.setPage, requested = props.requested, setRequested = props.setRequested;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)().userInfo;
    var notCurrent = page !== "quiz";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(0), currentQuestionIndex = ref[0], setCurrentQuestionIndex = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)({}), answers = ref1[0], setAnswers = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(0), progress = ref2[0], setProgress = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)([]), visitedQuestionIndices = ref3[0], setVisitedQuestionIndices = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(false), open = ref4[0], setOpen = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(null), options = ref5[0], setOptions = ref5[1];
    var currentOptions = quiz.data.pages[currentQuestionIndex].options;
    var findOptions = currentOptions.map(function(option) {
        return !!answers[option.id];
    });
    var isCurrentAnswered = answers[quiz.data.pages[currentQuestionIndex].id] ? true : findOptions.every(Boolean);
    var handleSelectAnswer = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(questionId, optionId) {
            var nextPage, _progress;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAnswers((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, answers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)({}, questionId, optionId)));
                        nextPage = getNextPage(optionId);
                        if (!(nextPage !== null)) return [
                            3,
                            1
                        ];
                        setProgress((_progress = quiz.data.pages[nextPage].progress) !== null && _progress !== void 0 ? _progress : 0);
                        setCurrentQuestionIndex(nextPage);
                        setVisitedQuestionIndices((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(visitedQuestionIndices).concat([
                            currentQuestionIndex
                        ]));
                        return [
                            3,
                            3
                        ];
                    case 1:
                        setProgress(100);
                        return [
                            4,
                            submitQuiz((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, answers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)({}, questionId, optionId)))
                        ];
                    case 2:
                        _state.sent();
                        setPage("plan");
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectAnswer(questionId, optionId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputAnswer = function(questionId, value) {
        setAnswers((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, answers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)({}, questionId, value)));
    };
    var handleButtonClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            var nextPage, _progress;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isCurrentAnswered) return [
                            2
                        ];
                        nextPage = getNextPage();
                        if (!(nextPage !== null)) return [
                            3,
                            1
                        ];
                        setProgress((_progress = quiz.data.pages[nextPage].progress) !== null && _progress !== void 0 ? _progress : 0);
                        setCurrentQuestionIndex(nextPage);
                        setVisitedQuestionIndices((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(visitedQuestionIndices).concat([
                            currentQuestionIndex
                        ]));
                        return [
                            3,
                            3
                        ];
                    case 1:
                        setProgress(100);
                        return [
                            4,
                            submitQuiz(answers)
                        ];
                    case 2:
                        _state.sent();
                        setPage("plan");
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var getNextPage = function(answer) {
        var currentPage = quiz.data.pages[currentQuestionIndex];
        var selectedOption = currentPage.options.find(function(option) {
            return option.id === answer;
        });
        if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type) === "select" && selectedOption.next_page) {
            return quiz.data.pages.findIndex(function(page) {
                return page.id === selectedOption.next_page;
            });
        } else {
            var nextPageId = currentPage.next_page;
            if (nextPageId) {
                return quiz.data.pages.findIndex(function(page) {
                    return page.id === nextPageId;
                });
            } else {
                return null;
            }
        }
    };
    var handlePrevPage = function() {
        var prevQuestionIndex = visitedQuestionIndices.pop();
        if (prevQuestionIndex !== undefined) {
            var prevQuestion = quiz.data.pages[currentQuestionIndex];
            var prevQuestionId = prevQuestion.id;
            var updatedAnswers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, answers);
            delete updatedAnswers[prevQuestionId];
            if (prevQuestion.options) {
                prevQuestion.options.forEach(function(option) {
                    if (updatedAnswers[option.id]) {
                        delete updatedAnswers[option.id];
                    }
                });
            }
            setAnswers(updatedAnswers);
            var _progress;
            setProgress((_progress = quiz.data.pages[prevQuestionIndex].progress) !== null && _progress !== void 0 ? _progress : 0);
            setCurrentQuestionIndex(prevQuestionIndex);
        }
    };
    function submitQuiz(newAnsweres, skip) {
        return _submitQuiz.apply(this, arguments);
    }
    function _submitQuiz() {
        _submitQuiz = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(newAnsweres, skip) {
            var payload, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setRequested(true);
                        payload = {
                            quiz_id: quiz.quiz_id,
                            uid: userInfo.userId,
                            answers: newAnsweres
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/quiz-submit", payload)
                        ];
                    case 2:
                        _state.sent();
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent(skip ? "w_dp_onboarding_skip" : "w_did_finish_quiz");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("txt_something_wrong")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setRequested(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _submitQuiz.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute right-0 top-0 tablet:right-[calc(50%-250px)]", "h-[100svh] w-full tablet:h-full tablet:w-[500px]", "flex items-center justify-center", "transition-all duration-500", page === "quiz" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.quiz ? "translate-y-24" : "-translate-x-32", 
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("fixed left-0 top-0 flex h-[100svh] w-[100vw] items-end justify-start bg-color-popup tablet:hidden", !open && "pointer-events-none opacity-0", "z-[120] transition-opacity"),
                id: "find-more-popup",
                onClick: function(event) {
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(event.target, Element)) {
                        if (event.target.id === event.currentTarget.id) {
                            setOpen(false);
                        }
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative h-[50svh] w-full rounded-t-[12px] bg-color-popup-cell pt-3 transition-all", open ? "translate-y-0" : "translate-y-full"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "no-scrollbar flex h-full w-full flex-col gap-[8px] overflow-y-auto rounded-[13px] bg-color-popup-cell px-[10px] py-[14px]",
                        children: options && options.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    handleSelectAnswer(quiz.data.pages[currentQuestionIndex].id, item.id);
                                    setOpen(false);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex w-full flex-row items-center rounded-[8px] px-4 py-3", answers[quiz.data.pages[currentQuestionIndex].id] === item.id && "bg-primary-100"),
                                children: item.title
                            }, item.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative h-full w-full overflow-auto px-6 tablet:overflow-visible tablet:px-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("no-scrollbar absolute left-0 top-0 flex h-full w-full flex-col items-center justify-start gap-3 px-6 transition-all tablet:left-[50px] tablet:w-[400px] tablet:px-0"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-4 mt-11 flex w-full flex-col items-center justify-center gap-2 text-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-center text-[22px] font-600 text-blue-800",
                                    children: t("txt_welcome")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-center text-[16px] font-400 text-blue-700",
                                    children: t("txt_tell_us")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative mb-[20px] h-[6px] w-full overflow-hidden rounded-[40px] bg-blue-200 tablet:w-[375px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    width: "".concat(progress, "%")
                                },
                                className: "absolute left-0 top-0 h-[6px] bg-primary-500 transition-all"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative h-full w-full", requested && "pointer-events-none opacity-40"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("fixed bottom-0 left-0 w-full bg-color-cell px-6 py-5 tablet:absolute tablet:-left-10 tablet:top-0 tablet:w-auto tablet:bg-[transparent] tablet:p-0", "z-[1] flex flex-row items-center justify-start tablet:items-start"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "button",
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("bg-blue-200 hover:bg-blue-100", "flex items-center justify-center transition-all duration-200", "h-10 w-10 rounded-full px-3", currentQuestionIndex === 0 && "pointer-events-none opacity-0"),
                                            onClick: handlePrevPage,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                width: "6",
                                                height: "12",
                                                viewBox: "0 0 6 12",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M5.12969 10.2594L0.871094 6.00078L5.12969 1.74219",
                                                    stroke: "var(--color-blue-900)",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex flex-1 items-center justify-center tablet:hidden",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                type: "button",
                                                onClick: function() {
                                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(e) {
                                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    e.preventDefault();
                                                                    return [
                                                                        4,
                                                                        submitQuiz({}, true)
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    setPage("plan");
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(e) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }(),
                                                disabled: notCurrent || requested,
                                                className: "-translate-x-5 text-[16px] font-400 text-blue-400 tablet:hidden",
                                                children: t("txt_skip_now")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "-right-[60px] bottom-4 z-[1] hidden h-[25px] w-auto tablet:absolute tablet:flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(e) {
                                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            e.preventDefault();
                                                            return [
                                                                4,
                                                                submitQuiz({}, true)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            setPage("plan");
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(e) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(),
                                        disabled: notCurrent || requested,
                                        className: "text-[16px] font-400 text-blue-400",
                                        children: t("txt_skip_now")
                                    })
                                }),
                                quiz.data.pages.map(function(question, index) {
                                    var getPositionInQuiz = function getPositionInQuiz(currentIndex, answersLength) {
                                        if (answersLength === currentIndex) {
                                            return "current";
                                        }
                                        if (answers[question.id] || isAnswered) {
                                            return "answered";
                                        }
                                        return "not_answered";
                                    };
                                    var options = question.options;
                                    var findOptions = options.map(function(option) {
                                        return !!answers[option.id];
                                    });
                                    var isAnswered = findOptions.every(Boolean);
                                    var position = getPositionInQuiz(index, currentQuestionIndex);
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                        onSubmit: function(e) {
                                            e.preventDefault();
                                            handleButtonClick();
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute left-0 top-0 flex h-full w-full flex-col items-center gap-3 transition-all duration-300", position === "not_answered" && "pointer-events-none translate-x-32 opacity-0", position === "current" && "translate-x-0 opacity-100", position === "answered" && " pointer-events-none -translate-x-32 opacity-0"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex w-full flex-col items-center tablet:w-[375px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-center text-[18px] font-600 text-blue-800",
                                                    children: question.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("no-scrollbar flex min-h-[200px] w-full flex-col items-center gap-[10px] overflow-y-scroll pb-[90px] tablet:min-h-0 tablet:overflow-auto tablet:p-0"),
                                                children: [
                                                    question.options.map(function(option) {
                                                        switch(option.type){
                                                            case "select":
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("group flex h-12 w-full shrink-0 flex-row items-center justify-between rounded-[8px] px-4 tablet:w-[375px]", answers[question.id] === option.id ? "bg-primary-100" : "bg-blue-100"),
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        handleSelectAnswer(question.id, option.id);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "text-[16px] font-500 text-blue-800",
                                                                            children: option.title
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "flex items-center justify-center transition-all [--icon-color:var(--color-blue-500)] desktop:-translate-x-1 desktop:opacity-0 desktop:group-hover:translate-x-0 desktop:group-hover:opacity-100",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightArrow, {})
                                                                        })
                                                                    ]
                                                                }, option.id);
                                                            case "text":
                                                                var _id;
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_border_input__WEBPACK_IMPORTED_MODULE_2__/* .BorderInput */ .Dp, {
                                                                    placeholder: option.hint,
                                                                    type: option.input_type,
                                                                    className: "w-full !bg-color-background tablet:w-[375px]",
                                                                    value: (_id = answers[option.id]) !== null && _id !== void 0 ? _id : "",
                                                                    onChange: function(e) {
                                                                        handleInputAnswer(option.id, e.currentTarget.value);
                                                                    }
                                                                }, option.id);
                                                            case "find":
                                                                var ref, ref1;
                                                                var ref2, ref3;
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
                                                                            triggerClassName: "w-full hidden tablet:block tablet:w-[375px]",
                                                                            className: "hidden w-full tablet:block tablet:w-[375px]",
                                                                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("hidden h-12 w-full items-center justify-between rounded-[8px] px-4 tablet:flex tablet:w-[375px]", option.options.find(function(a) {
                                                                                    return a.id === answers[question.id];
                                                                                }) ? "bg-primary-500/20" : "border border-color-separator bg-color-cell"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        className: "text-[16px] font-500 text-blue-800",
                                                                                        children: (ref2 = (ref = option.options.find(function(a) {
                                                                                            return a.id === answers[question.id];
                                                                                        })) === null || ref === void 0 ? void 0 : ref.title) !== null && ref2 !== void 0 ? ref2 : option.hint
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .ButtonArrowIcon */ .hd, {})
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "absolute z-10 w-[375px] pt-2",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "no-scrollbar max-h-[150px] w-full overflow-y-scroll rounded-[10px] border border-color-separator bg-blue-200 [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "flex w-full flex-col",
                                                                                        children: option.options.map(function(item) {
                                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                onClick: function(e) {
                                                                                                    e.preventDefault();
                                                                                                    handleSelectAnswer(question.id, item.id);
                                                                                                },
                                                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center justify-start px-4 py-2 text-start text-[16px] font-500 text-blue-800 transition-all", answers[question.id] === item.id ? "bg-primary-500/20" : "bg-blue-200 hover:bg-blue-300"),
                                                                                                children: item.title
                                                                                            }, item.id);
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        }, option.id),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                            onClick: function(e) {
                                                                                e.preventDefault();
                                                                                setOptions(option.options);
                                                                                setOpen(true);
                                                                            },
                                                                            type: "button",
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex h-12 w-full shrink-0 items-center justify-between rounded-[8px] px-4 tablet:hidden", option.options.find(function(a) {
                                                                                return a.id === answers[question.id];
                                                                            }) ? "bg-primary-500/20" : "border border-color-separator bg-color-cell"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                    className: "text-[16px] font-500 text-blue-800",
                                                                                    children: (ref3 = (ref1 = option.options.find(function(a) {
                                                                                        return a.id === answers[question.id];
                                                                                    })) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref3 !== void 0 ? ref3 : option.hint
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .ButtonArrowIcon */ .hd, {})
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                });
                                                        }
                                                    }),
                                                    question.button_text !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                                        type: "submit",
                                                        primary: true,
                                                        className: "w-full tablet:w-[375px]",
                                                        disabled: notCurrent || requested || !isAnswered,
                                                        text: question.button_text
                                                    })
                                                ]
                                            })
                                        ]
                                    }, question.id);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function PlanSection(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var setPage = props.setPage, page = props.page, setMetaTitle = props.setMetaTitle, redirectUrl = props.redirectUrl;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_18__.useRouter)();
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)().userInfo;
    var prices = (0,react_query__WEBPACK_IMPORTED_MODULE_20__.useQuery)({
        queryKey: [
            "offering-prices"
        ],
        queryFn: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .fetchOfferingPrices */ .uK)(),
        staleTime: Infinity,
        cacheTime: Infinity
    });
    var ref12 = (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getCurrentPackId */ .V2)(userInfo.entitlements), currentPackId = ref12.packId;
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(true), isYearly = ref13[0], setIsYearly = ref13[1];
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_19__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationContext */ .u).notify;
    function handlePurchaseClick(packId) {
        return _handlePurchaseClick.apply(this, arguments);
    }
    function _handlePurchaseClick() {
        _handlePurchaseClick = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(packId) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                if (!userInfo.isAnonymous) {
                    fetchPaymentLink(packId);
                } else {
                    setPage("signin");
                    setMetaTitle("txt_login_title");
                }
                return [
                    2
                ];
            });
        });
        return _handlePurchaseClick.apply(this, arguments);
    }
    function fetchPaymentLink(packId) {
        return _fetchPaymentLink.apply(this, arguments);
    }
    function _fetchPaymentLink() {
        _fetchPaymentLink = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(packId) {
            var sessionId, payload, _tmp, ref, url, currency, value, paymentData, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        sessionId = (0,uuid__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)();
                        _tmp = {
                            location: typeof redirectUrl === "string" ? redirectUrl : "/",
                            period: isYearly ? "yearly" : "monthly"
                        };
                        return [
                            4,
                            (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getAdId */ .YF)()
                        ];
                    case 1:
                        payload = (_tmp.adId = _state.sent(), _tmp.sessionId = sessionId, _tmp.offering = packId, _tmp);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/payment-stripe-url", payload).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), url = ref.url, currency = ref.currency, value = ref.value;
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("initiate_checkout");
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("w_onboarding_success");
                        paymentData = {
                            currency: currency,
                            value: value,
                            session: sessionId
                        };
                        localStorage.setItem(_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .PAYMENT_DATA_KEY */ .kV, JSON.stringify(paymentData));
                        router.push(url);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("txt_could_not_purchase_now")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        window.blur();
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchPaymentLink.apply(this, arguments);
    }
    function handleSkip() {
        return _handleSkip.apply(this, arguments);
    }
    function _handleSkip() {
        _handleSkip = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            var url;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "/";
                        if (typeof redirectUrl === "string") {
                            url = redirectUrl;
                        }
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("w_onboarding_success");
                        return [
                            4,
                            router.push(url)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSkip.apply(this, arguments);
    }
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var yearlyPricePro = ((ref1 = (ref = prices.data) === null || ref === void 0 ? void 0 : ref.plans.basic.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref1 === void 0 ? void 0 : ref1.price) || 0;
    var yearlyPriceDividedPro = yearlyPricePro / 12;
    var yearlyPriceFormattedPro = Math.floor(yearlyPriceDividedPro);
    var yearlyPriceAdvanced = ((ref3 = (ref2 = prices.data) === null || ref2 === void 0 ? void 0 : ref2.plans.advanced.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref3 === void 0 ? void 0 : ref3.price) || 0;
    var yearlyPriceDividedAdvanced = yearlyPriceAdvanced / 12;
    var yearlyPriceFormattedAdvanced = Math.floor(yearlyPriceDividedAdvanced);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("no-scrollbar absolute left-0 top-0 overflow-auto py-11 transition-all", "flex h-full w-full flex-col items-center justify-start gap-3", "tablet:pt-0", page === "plan" ? [
            "opacity-100 delay-200",
            "translate-y-0"
        ] : [
            "pointer-events-none opacity-0",
            sectionOrder[page] > sectionOrder.plan ? "translate-x-32" : "-translate-x-32", 
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[22px] font-700 text-blue-800 tablet:pt-10 tablet:text-[20px] desktop:pt-0",
                children: t("txt_unlock_all_features")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " flex gap-[10px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(isYearly ? "text-blue-500" : "text-blue-900", "text-[18px] font-500 transition-colors"),
                        children: t("txt_monthly")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_toggle__WEBPACK_IMPORTED_MODULE_10__/* .SquareSwitch */ .ZP, {
                        onChange: setIsYearly,
                        enabled: isYearly
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(isYearly ? "text-blue-900" : "text-blue-500", "text-[18px] font-500 transition-colors"),
                        children: t("txt_yearly")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-[18px] font-500 transition-colors", isYearly ? "text-blue-900" : "text-blue-500"),
                        children: t("fs_save_percent", {
                            percent: String(plans.save_percent)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex w-full flex-col items-center justify-center gap-4 px-4 tablet:px-5 desktop:px-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex w-full flex-col overflow-hidden rounded-[8px] border-2 border-color-separator", "tablet:flex-row"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-1 flex-col justify-between bg-color-surface-cell px-4 pb-4 pt-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col desktop:mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[24px] font-600 text-blue-900",
                                                children: "Pro + AI"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-300 text-[14px] text-blue-600",
                                                children: "For pro video creation"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "relative mt-3 h-[31px] w-full overflow-hidden",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute inset-0", "flex h-[31px] w-full flex-row items-end justify-start gap-[2px]", isYearly && "-top-8", "transition-all duration-500"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[26px] leading-[31px]"),
                                                                children: [
                                                                    "$",
                                                                    String((ref5 = (ref4 = prices.data) === null || ref4 === void 0 ? void 0 : ref4.plans.basic.variants[0].periods.find(function(a) {
                                                                        return a.period === "monthly";
                                                                    })) === null || ref5 === void 0 ? void 0 : ref5.price).slice(0, -2),
                                                                    ".",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                        children: String((ref7 = (ref6 = prices.data) === null || ref6 === void 0 ? void 0 : ref6.plans.basic.variants[0].periods.find(function(a) {
                                                                            return a.period === "monthly";
                                                                        })) === null || ref7 === void 0 ? void 0 : ref7.price).slice(-2)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-300 mb-1 text-[14px] lowercase text-blue-600",
                                                                children: [
                                                                    "/",
                                                                    t("txt_month")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute inset-0", "flex h-[31px] w-full flex-row items-end justify-start gap-[2px]", !isYearly && "top-8", "transition-all duration-500"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[26px] leading-[31px]"),
                                                                children: [
                                                                    "$",
                                                                    String(yearlyPriceFormattedPro).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedPro).slice(0, -2) : 0,
                                                                    ".",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                        children: String(yearlyPriceFormattedPro).slice(-2)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-300 mb-1 text-[14px] lowercase text-blue-600",
                                                                children: [
                                                                    "/",
                                                                    t("txt_month"),
                                                                    "*"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* .GradientGrayscaleButton */ .sH, {
                                            grayscale: true,
                                            disabled: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getBasicButtonText */ .hv)(currentPackId) === "txt_current_plan",
                                            onClick: function() {
                                                var ref;
                                                return handlePurchaseClick(((ref = prices.data) === null || ref === void 0 ? void 0 : ref.plans.basic.variants[0].pack_id) || "");
                                            },
                                            className: "flex h-[52px] w-full items-center justify-center !font-500 disabled:!text-color-inactive-text",
                                            text: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getBasicButtonText */ .hv)(currentPackId)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col gap-2 bg-blue-50 p-4 tablet:w-[280px]",
                                children: plans.plans.basic.points.map(function(point) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center gap-[10px] ",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_6__/* .CustomThemedResource */ .aK, {
                                                format: "svg",
                                                source: "/pricing/check"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[14px] font-400 text-blue-800",
                                                children: point
                                            })
                                        ]
                                    }, point);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative flex w-full flex-col rounded-[8px]", "tablet:flex-row"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    background: "linear-gradient(120deg, rgba(134, 54, 248, 1), rgba(240, 32, 179, 1), rgba(248, 71, 94, 1), rgba(255, 148, 33, 1) )"
                                },
                                className: "absolute left-[-2px] top-[-2px] h-[calc(100%+4px)] w-[calc(100%+4px)] rounded-[10px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "z-10 flex w-full flex-1 flex-col justify-between rounded-t-[8px] bg-color-cell px-4 pb-4 pt-3 tablet:rounded-l-[8px] tablet:rounded-r-[0px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[24px] font-600 text-blue-900",
                                                children: "Advanced + AI"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-300 text-[14px] text-blue-600",
                                                children: t("txt_pro_subtitle")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "relative mt-3 h-[50px] w-full overflow-hidden",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", isYearly && "-top-16", "transition-all duration-500"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[38px]"),
                                                                children: [
                                                                    "$",
                                                                    String((ref9 = (ref8 = prices.data) === null || ref8 === void 0 ? void 0 : ref8.plans.advanced.variants[0].periods.find(function(a) {
                                                                        return a.period === "monthly";
                                                                    })) === null || ref9 === void 0 ? void 0 : ref9.price).slice(0, -2),
                                                                    ".",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                        children: String((ref11 = (ref10 = prices.data) === null || ref10 === void 0 ? void 0 : ref10.plans.advanced.variants[0].periods.find(function(a) {
                                                                            return a.period === "monthly";
                                                                        })) === null || ref11 === void 0 ? void 0 : ref11.price).slice(-2)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                                children: [
                                                                    "/",
                                                                    t("txt_month")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", !isYearly && "top-16", "transition-all duration-500"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[38px]"),
                                                                children: [
                                                                    "$",
                                                                    String(yearlyPriceFormattedAdvanced).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedAdvanced).slice(0, -2) : 0,
                                                                    ".",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                        children: String(yearlyPriceFormattedAdvanced).slice(-2)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                                children: [
                                                                    "/",
                                                                    t("txt_month"),
                                                                    "*"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: " mt-4 flex w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            gradient: true,
                                            disabled: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getAdvancedButtonText */ .JH)(currentPackId) === "txt_current_plan",
                                            onClick: function() {
                                                var ref;
                                                return handlePurchaseClick(((ref = prices.data) === null || ref === void 0 ? void 0 : ref.plans.advanced.variants[0].pack_id) || "");
                                            },
                                            className: "flex h-[52px] w-full items-center justify-center !font-500",
                                            text: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getAdvancedButtonText */ .JH)(currentPackId)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-10 h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-10 flex flex-col gap-2 rounded-b-[8px] bg-blue-50 p-4 tablet:w-[280px] tablet:rounded-l-[0px] tablet:rounded-r-[8px]",
                                children: plans.plans.advanced.points.map(function(point) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center gap-[10px] ",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_6__/* .CustomThemedResource */ .aK, {
                                                format: "svg",
                                                source: "/pricing/check"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[14px] font-400 text-blue-800",
                                                children: point
                                            })
                                        ]
                                    }, point);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(" text-[16px] font-400 text-blue-500 transition-opacity", !isYearly && "hidden"),
                        children: [
                            "*",
                            t("txt_billed_yearly")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function(e) {
                            e.preventDefault();
                            handleSkip();
                        },
                        className: "text-[16px] font-400 text-blue-400",
                        children: t("txt_skip_now")
                    })
                ]
            })
        ]
    });
}
var MIN_PASSWORD_CHARACTERS = 6;
function checkPasswordProperties(password) {
    var hasUpperCase = password.match(/[A-Z]/) !== null;
    var hasLowerCase = password.match(/[a-z]/) !== null;
    var symbols = password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/) !== null;
    var numbers = password.match(/[0-9]/) !== null;
    var enoughCharacters = password.length >= MIN_PASSWORD_CHARACTERS;
    return {
        upperLowerCase: hasUpperCase && hasLowerCase,
        symbols: symbols,
        numbers: numbers,
        enoughCharacters: enoughCharacters
    };
}
function getPasswordLevelFromProperties(properties) {
    var upperLowerCase = properties.upperLowerCase, symbols = properties.symbols, numbers = properties.numbers, enoughCharacters = properties.enoughCharacters;
    var requirements = [
        upperLowerCase,
        symbols,
        numbers,
        enoughCharacters, 
    ];
    var level = requirements.filter(function(requirement) {
        return requirement;
    }).length;
    return level;
}
var levelTexts = [
    "txt_must_have_characters",
    "txt_weak_password",
    "txt_average_password",
    "txt_good_password",
    "txt_strong_password", 
];
var PROGRESS_COUNT = 4;
function PasswordCheckPopup(props) {
    var password = props.password;
    var passwordProperties = checkPasswordProperties(password);
    var level = getPasswordLevelFromProperties(passwordProperties);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var progressCount = new Array(PROGRESS_COUNT).fill(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "password-check",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("peer-focus:pointer-events-auto peer-focus:opacity-100", "peer-focus:translate-y-4", "peer-focus:desktop:-translate-x-full peer-focus:desktop:-translate-y-1/2", "pointer-events-none opacity-0", "transition-all duration-300 ease-in-out", "absolute left-0 top-full z-40 w-[300px]", "desktop:-left-6 desktop:top-1/2", "flex flex-col items-stretch gap-4", "rounded-[12px] bg-color-cell p-[22px]", "[box-shadow:0px_0px_30px_rgba(0,0,0,0.13)]", "translate-y-8", "desktop:-translate-x-[110%] desktop:-translate-y-1/2", "pointer-events-none"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute -right-2 top-1/2 hidden h-6 w-6 -translate-y-1/2 rotate-45 rounded-md bg-color-cell desktop:block"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative h-[27px]",
                children: levelTexts.map(function(text, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("text-[18px] font-600", "absolute left-0 top-0", index !== level ? [
                            "opacity-0",
                            index > level ? "translate-y-6" : "-translate-y-6", 
                        ] : [
                            "opacity-100 delay-100",
                            "translate-y-0", 
                        ], "transition-all duration-200 ease-in-out"),
                        children: t(text)
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex gap-1",
                children: progressCount.map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PasswordCheckProgress, {
                        index: index,
                        level: level
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PasswordRecommendations, {
                properties: passwordProperties
            })
        ]
    });
}
function PasswordRecommendations(props) {
    var properties = props.properties;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: t("txt_its_better_to_have")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-2 pl-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PasswordRecommendationTick, {
                        checked: properties.upperLowerCase,
                        children: t("txt_upper_and_lower_case")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PasswordRecommendationTick, {
                        checked: properties.symbols,
                        children: t("txt_a_symbol")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PasswordRecommendationTick, {
                        checked: properties.numbers,
                        children: t("txt_numbers")
                    })
                ]
            })
        ]
    });
}
function PasswordRecommendationTick(props) {
    var checked = props.checked, children = props.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative pl-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/green-tick.svg"),
                alt: "checked",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2", checked ? "opacity-100 delay-100" : "opacity-0", "transition-opacity duration-200 ease-in-out", "h-4 w-4")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2", checked ? "opacity-0" : "opacity-100 delay-100", "transition-opacity duration-200 ease-in-out", "h-[6px] w-[6px] rotate-45 bg-blue-100")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            })
        ]
    });
}
function PasswordCheckProgress(props) {
    var index = props.index, level = props.level;
    var colors = [
        "bg-[transparent]",
        "bg-[#F8665B]",
        "bg-[#F3A23A]",
        "bg-[#47A8F8]",
        "bg-[#09C185]", 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("h-1 flex-1 overflow-hidden rounded-full bg-color-separator"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(index < level ? [
                "w-full",
                colors[level]
            ] : [
                "w-0"
            ], "h-full", "transition-all duration-300 ease-in-out")
        })
    });
}
var RightArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 11C20 11.2652 19.8946 11.5196 19.7071 11.7071L13.7071 17.7071C13.3166 18.0976 12.6834 18.0976 12.2929 17.7071C11.9024 17.3166 11.9024 16.6834 12.2929 16.2929L17.5858 11L12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L19.7071 10.2929C19.8946 10.4804 20 10.7348 20 11Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 11C19 11.5523 18.5523 12 18 12L5 12C4.44771 12 4 11.5523 4 11C4 10.4477 4.44771 10 5 10L18 10C18.5523 10 19 10.4477 19 11Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};


/***/ }),

/***/ 9480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ notEmpty; },
/* harmony export */   "Jh": function() { return /* binding */ isEmail; },
/* harmony export */   "Mn": function() { return /* binding */ isPhone; }
/* harmony export */ });
/* unused harmony export isPhoneOrEmpty */
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9637);

var notEmpty = function(value, t) {
    if (value.length === 0) return t("txt_error_not_empty");
};
var isEmail = function(value, t) {
    var atIndex = value.indexOf("@");
    var dotIndex = value.lastIndexOf(".");
    var atSymbols = value.split("@");
    if (atIndex === 0) return t("txt_error_cannot_start_with_at");
    if (atIndex === -1) return t("txt_error_should_contain_at");
    if (dotIndex === -1 || dotIndex < atIndex || dotIndex === value.length - 1) return t("txt_error_email_wrong_domain");
    if (atSymbols.length > 2) return t("txt_error_email_one_at");
};
var isPhone = function(value, t) {
    var plusIndex = value.lastIndexOf("+");
    if (plusIndex !== 0 && plusIndex !== -1) return t("txt_error_plus_middle");
    var ref = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value.split("")), _ = ref[0], numbers = ref.slice(1);
    if (numbers.join("").match(/[^0-9\s]/) !== null) return t("txt_error_only_numbers_and_plus");
    if (value.length <= 6) return t("txt_error_short_phone");
    if (value[0] !== "0" && value[0] !== "+") return t("txt_error_phone_format");
};
var isPhoneOrEmpty = function(value, t) {
    if (!value) {
        return undefined;
    }
    return isPhone(value, t);
};


/***/ })

}]);